// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file pull_requests/v1/review_requests.proto (package github.pull_requests.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Reviewer } from "./reviewer_pb";
import { file_pull_requests_v1_reviewer } from "./reviewer_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pull_requests/v1/review_requests.proto.
 */
export const file_pull_requests_v1_review_requests: GenFile = /*@__PURE__*/
  fileDesc("CiZwdWxsX3JlcXVlc3RzL3YxL3Jldmlld19yZXF1ZXN0cy5wcm90bxIXZ2l0aHViLnB1bGxfcmVxdWVzdHMudjEirQEKFlJldmlld1JlcXVlc3RzUmVzcG9uc2USTgoXcGVuZGluZ19yZXZpZXdfcmVxdWVzdHMYASADKAsyLS5naXRodWIucHVsbF9yZXF1ZXN0cy52MS5QZW5kaW5nUmV2aWV3UmVxdWVzdBJDChFjb21wbGV0ZWRfcmV2aWV3cxgCIAMoCzIoLmdpdGh1Yi5wdWxsX3JlcXVlc3RzLnYxLkNvbXBsZXRlZFJldmlldyKbAgoUUGVuZGluZ1Jldmlld1JlcXVlc3QSMwoIcmV2aWV3ZXIYASABKAsyIS5naXRodWIucHVsbF9yZXF1ZXN0cy52MS5SZXZpZXdlchIVCg1pc19jb2RlX293bmVyGAIgASgIEiUKHWlzX2NvZGVfb3duZXJfZnJvbV9kZWxlZ2F0aW9uGAMgASgIEjwKDWRlZmVycmVkX3R5cGUYBCABKA4yJS5naXRodWIucHVsbF9yZXF1ZXN0cy52MS5EZWZlcnJlZFR5cGUSPgoTZGVsZWdhdGVkX2Zyb21fdGVhbRgFIAEoCzIhLmdpdGh1Yi5wdWxsX3JlcXVlc3RzLnYxLlJldmlld2VyEhIKCmNyZWF0ZWRfYXQYBiABKAkioAIKD0NvbXBsZXRlZFJldmlldxIKCgJpZBgBIAEoAxIzCghyZXZpZXdlchgCIAEoCzIhLmdpdGh1Yi5wdWxsX3JlcXVlc3RzLnYxLlJldmlld2VyEjMKBXN0YXRlGAMgASgOMiQuZ2l0aHViLnB1bGxfcmVxdWVzdHMudjEuUmV2aWV3U3RhdGUSEAoIaGVhZF9zaGEYBCABKAkSFAoMc3VibWl0dGVkX2F0GAUgASgJEhgKEGhhc193cml0ZV9hY2Nlc3MYBiABKAgSFgoOY2FuX3JlX3JlcXVlc3QYByABKAgSPQoSb25fYmVoYWxmX29mX3RlYW1zGAggAygLMiEuZ2l0aHViLnB1bGxfcmVxdWVzdHMudjEuUmV2aWV3ZXIqZQoMRGVmZXJyZWRUeXBlEh0KGURFRkVSUkVEX1RZUEVfVU5TUEVDSUZJRUQQABIbChdERUZFUlJFRF9UWVBFX0NPREVPV05FUhABEhkKFURFRkVSUkVEX1RZUEVfQ09QSUxPVBACKrwBCgtSZXZpZXdTdGF0ZRIcChhSRVZJRVdfU1RBVEVfVU5TUEVDSUZJRUQQABIYChRSRVZJRVdfU1RBVEVfUEVORElORxABEhoKFlJFVklFV19TVEFURV9DT01NRU5URUQQAhIZChVSRVZJRVdfU1RBVEVfQVBQUk9WRUQQAxIiCh5SRVZJRVdfU1RBVEVfQ0hBTkdFU19SRVFVRVNURUQQBBIaChZSRVZJRVdfU1RBVEVfRElTTUlTU0VEEAViBnByb3RvMw", [file_pull_requests_v1_reviewer]);

/**
 * Response payload for
 * GET /:owner/:repo/pull/:number/page_data/review_requests
 *
 * Defined by PullRequests::PageData::SharedController#review_requests.
 *
 * @generated from message github.pull_requests.v1.ReviewRequestsResponse
 */
export type ReviewRequestsResponse = Message<"github.pull_requests.v1.ReviewRequestsResponse"> & {
  /**
   * @generated from field: repeated github.pull_requests.v1.PendingReviewRequest pending_review_requests = 1;
   */
  pendingReviewRequests: PendingReviewRequest[];

  /**
   * @generated from field: repeated github.pull_requests.v1.CompletedReview completed_reviews = 2;
   */
  completedReviews: CompletedReview[];
};

/**
 * Describes the message github.pull_requests.v1.ReviewRequestsResponse.
 * Use `create(ReviewRequestsResponseSchema)` to create a new message.
 */
export const ReviewRequestsResponseSchema: GenMessage<ReviewRequestsResponse> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_review_requests, 0);

/**
 * @generated from message github.pull_requests.v1.PendingReviewRequest
 */
export type PendingReviewRequest = Message<"github.pull_requests.v1.PendingReviewRequest"> & {
  /**
   * @generated from field: github.pull_requests.v1.Reviewer reviewer = 1;
   */
  reviewer?: Reviewer;

  /**
   * @generated from field: bool is_code_owner = 2;
   */
  isCodeOwner: boolean;

  /**
   * @generated from field: bool is_code_owner_from_delegation = 3;
   */
  isCodeOwnerFromDelegation: boolean;

  /**
   * Deferred reason; UNSPECIFIED (omitted) for an active request.
   *
   * @generated from field: github.pull_requests.v1.DeferredType deferred_type = 4;
   */
  deferredType: DeferredType;

  /**
   * Delegating team; absent when the request was not delegated (legacy null).
   *
   * @generated from field: github.pull_requests.v1.Reviewer delegated_from_team = 5;
   */
  delegatedFromTeam?: Reviewer;

  /**
   * ISO 8601 timestamp; absent for deferred requests (legacy null).
   *
   * @generated from field: string created_at = 6;
   */
  createdAt: string;
};

/**
 * Describes the message github.pull_requests.v1.PendingReviewRequest.
 * Use `create(PendingReviewRequestSchema)` to create a new message.
 */
export const PendingReviewRequestSchema: GenMessage<PendingReviewRequest> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_review_requests, 1);

/**
 * @generated from message github.pull_requests.v1.CompletedReview
 */
export type CompletedReview = Message<"github.pull_requests.v1.CompletedReview"> & {
  /**
   * Review id. int64 (serialized as a JSON string) since ids can exceed the
   * int32 range.
   *
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: github.pull_requests.v1.Reviewer reviewer = 2;
   */
  reviewer?: Reviewer;

  /**
   * @generated from field: github.pull_requests.v1.ReviewState state = 3;
   */
  state: ReviewState;

  /**
   * @generated from field: string head_sha = 4;
   */
  headSha: string;

  /**
   * ISO 8601 timestamp.
   *
   * @generated from field: string submitted_at = 5;
   */
  submittedAt: string;

  /**
   * @generated from field: bool has_write_access = 6;
   */
  hasWriteAccess: boolean;

  /**
   * @generated from field: bool can_re_request = 7;
   */
  canReRequest: boolean;

  /**
   * @generated from field: repeated github.pull_requests.v1.Reviewer on_behalf_of_teams = 8;
   */
  onBehalfOfTeams: Reviewer[];
};

/**
 * Describes the message github.pull_requests.v1.CompletedReview.
 * Use `create(CompletedReviewSchema)` to create a new message.
 */
export const CompletedReviewSchema: GenMessage<CompletedReview> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_review_requests, 2);

/**
 * Why a pending review request is deferred. UNSPECIFIED is an active
 * (non-deferred) request, which the legacy JSON encodes as null.
 *
 * @generated from enum github.pull_requests.v1.DeferredType
 */
export enum DeferredType {
  /**
   * @generated from enum value: DEFERRED_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DEFERRED_TYPE_CODEOWNER = 1;
   */
  CODEOWNER = 1,

  /**
   * @generated from enum value: DEFERRED_TYPE_COPILOT = 2;
   */
  COPILOT = 2,
}

/**
 * Describes the enum github.pull_requests.v1.DeferredType.
 */
export const DeferredTypeSchema: GenEnum<DeferredType> = /*@__PURE__*/
  enumDesc(file_pull_requests_v1_review_requests, 0);

/**
 * State of a completed review. The legacy JSON encodes this as a lowercase
 * string ("approved", "commented", "changes_requested", "dismissed",
 * "pending").
 *
 * @generated from enum github.pull_requests.v1.ReviewState
 */
export enum ReviewState {
  /**
   * @generated from enum value: REVIEW_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REVIEW_STATE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: REVIEW_STATE_COMMENTED = 2;
   */
  COMMENTED = 2,

  /**
   * @generated from enum value: REVIEW_STATE_APPROVED = 3;
   */
  APPROVED = 3,

  /**
   * @generated from enum value: REVIEW_STATE_CHANGES_REQUESTED = 4;
   */
  CHANGES_REQUESTED = 4,

  /**
   * @generated from enum value: REVIEW_STATE_DISMISSED = 5;
   */
  DISMISSED = 5,
}

/**
 * Describes the enum github.pull_requests.v1.ReviewState.
 */
export const ReviewStateSchema: GenEnum<ReviewState> = /*@__PURE__*/
  enumDesc(file_pull_requests_v1_review_requests, 1);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(ReviewRequestsResponseSchema, "ee40ff37b355")
registerSchemaHash(PendingReviewRequestSchema, "b56b9fc020c8")
registerSchemaHash(CompletedReviewSchema, "4e22be5d40a1")
